import { useState } from "react";
import { Eye, ArrowRight } from "lucide-react";

export const QuestionCard = ({ q, value, onAnswer }) => {
  const [revealed, setRevealed] = useState(!q.stimulus);
  const [studied, setStudied] = useState(false);
  const likert = q.type === "likert";

  if (q.stimulus && !studied) {
    return (
      <div data-testid="memory-stimulus-card" className="fade-up">
        <p className="overline-label mb-4">Memorize this</p>
        <div className="rounded-2xl bg-[#1C242B] text-[#FAF8F5] p-10 text-center font-mono-ui text-xl sm:text-2xl tracking-wide" data-testid="memory-stimulus">
          {q.stimulus}
        </div>
        <button data-testid="memory-ready-btn" onClick={() => { setStudied(true); setRevealed(true); }}
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#3E6B5C] text-white px-6 py-3 font-medium hover:bg-[#2F5548] transition-colors">
          <Eye size={16} /> I've memorized it, hide &amp; continue <ArrowRight size={16} />
        </button>
      </div>
    );
  }

  return (
    <div className="fade-up" key={q.id}>
      <h2 data-testid="question-prompt" className="font-display text-xl sm:text-2xl font-semibold leading-snug text-[#1C242B]">{q.prompt}</h2>
      {revealed && (
        <div className={`mt-8 grid gap-3 ${likert ? "sm:grid-cols-5" : "sm:grid-cols-2"}`}>
          {q.options.map((opt, i) => {
            const val = likert ? i : i;
            const active = value === val;
            return (
              <button key={i} data-testid={`option-${i}`} onClick={() => onAnswer(val)}
                className={`text-left rounded-xl border px-5 py-4 transition-colors duration-200 ${likert ? "sm:text-center text-sm" : ""} ${
                  active ? "border-[#D96B43] bg-[#D96B43]/10 text-[#1C242B] ring-2 ring-[#D96B43]/30" : "border-[#1C242B]/12 bg-white hover:border-[#1C242B]/40"}`}>
                {!likert && <span className="font-mono-ui text-xs text-slate-400 mr-3">{String.fromCharCode(65 + i)}</span>}
                <span className="font-medium">{opt}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
